import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  GetTestConfigTasksResponse,
  RunHistoryQuery
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetTestConfigTasksResponse) => ReactElement
  onSuccess?: (data: GetTestConfigTasksResponse) => void
  params?: RunHistoryQuery
}

const GetAiTestConfigTasksRequest = ({
  children,
  onSuccess,
  params
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiTestConfigTasksRequest
